import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PriceDataService, ProductPrice, ProductPriceInput } from '@vi-succ/util-prices';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EtProductPriceDataServiceService implements PriceDataService {
  constructor(private http: HttpClient) {}
  getPrice(salesOrg: string, productPriceInputs: ProductPriceInput[]): Observable<ProductPrice[]> {
    // We mock the request here, because the real API requires a auth token

    // which we do not have in this demo.
    /*const outputs: ProductPrice[] = productPriceInputs.map((input) => ({
      materialNumber: input.materialNumber,
      grossPrice: input.grossPrice,
      netPrice: input.grossPrice * 0.8,
      materialType: input.materialType,
      currency: 'EUR',
    }));
    return of(outputs).pipe(delay(1000));*/

    return this.http.post<ProductPrice[]>(`${environment.backend.url}/discounts`, productPriceInputs, {
      params: {
        salesOrg,
      },
    });
  }
}
